var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.networkData)?_c('NetworkForm',{attrs:{"handle-submit":_vm.handleSubmit,"defaults":_vm.networkData,"disabled":_vm.disabled}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }